"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var webAApi_1 = require("../../../../api/webAApi");
var ReportTotalProfitListCtl = /** @class */ (function (_super) {
    __extends(ReportTotalProfitListCtl, _super);
    function ReportTotalProfitListCtl(errDialog, controller) {
        var _this = _super.call(this, true) || this;
        _this.dk_usr_partner_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.usr_partner_id; });
        _this.dk_usr_partner_login = UIUtils_1.UIUtils.IProp2Str(function (o) { o.usr_partner_login; });
        _this.dk_usr_partner_subagents_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.usr_partner_subagents_count; });
        _this.dk_total_deposits_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.total_deposits_count; });
        _this.dk_total_withdraws_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.total_withdraws_count; });
        _this.dk_total_deposit_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.total_deposit_amount; });
        _this.dk_total_withdraw_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.total_withdraw_amount; });
        _this.dk_total_bet_money_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.total_bet_money_amount; });
        _this.dk_total_win_money_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.total_win_money_amount; });
        _this.dk_total_bet_bonus_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.total_bet_bonus_amount; });
        _this.dk_total_win_bonus_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.total_win_bonus_amount; });
        _this.dk_total_brand_ggr_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.total_brand_ggr_amount; });
        _this.dk_total_sub_partner_profit_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.total_sub_partner_profit_amount; });
        _this.dk_total_own_partner_profit_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.total_own_partner_profit_amount; });
        _this.dk_total_brand_profit_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.total_brand_profit_amount; });
        _this.dk_total_completed_bonus_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.total_completed_bonus_amount; });
        _this.dk_total_completed_bonus_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.total_completed_bonus_count; });
        _this._errDialog = errDialog;
        _this._controller = controller;
        return _this;
    }
    ReportTotalProfitListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total_count: 0,
            app_currency_id: 0,
            app_currency_iso: "",
            app_currency_symbol: "",
            total_total_deposits_count: 0,
            total_total_withdraws_count: 0,
            total_total_deposit_amount: 0,
            total_total_withdraw_amount: 0,
            total_total_bet_money_amount: 0,
            total_total_win_money_amount: 0,
            total_total_bet_bonus_amount: 0,
            total_total_win_bonus_amount: 0,
            total_total_brand_ggr_amount: 0,
            total_total_sub_partner_profit_amount: 0,
            total_total_own_partner_profit_amount: 0,
            total_total_brand_profit_amount: 0,
            total_total_completed_bonus_amount: 0,
            total_total_completed_bonus_count: 0,
            data_total: []
        };
    };
    ReportTotalProfitListCtl.prototype.LoadData = function (dtRange, onDone) {
        var _this = this;
        webAApi_1.ListBrandAndPartnersProfitReportByDateRangeGet.exec({
            from_year: dtRange.from_year,
            from_month: dtRange.from_month,
            from_day: dtRange.from_day,
            to_year: dtRange.to_year,
            to_month: dtRange.to_month,
            to_day: dtRange.to_day,
            brands_id_list: dtRange.brands_id_list,
            all_brands: dtRange.all_brands,
            app_currency_id: dtRange.app_currency_id,
            skip_zero_partners: dtRange.skip_zero_partners
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.data_total = [];
            _this.DATA.total_count = resp.total_count;
            _this.DATA.app_currency_id = resp.app_currency_id;
            _this.DATA.app_currency_iso = resp.app_currency_iso;
            _this.DATA.app_currency_symbol = resp.app_currency_symbol;
            _this.DATA.total_total_deposits_count = resp.total_total_deposits_count;
            _this.DATA.total_total_withdraws_count = resp.total_total_withdraws_count;
            _this.DATA.total_total_deposit_amount = resp.total_total_deposit_amount;
            _this.DATA.total_total_withdraw_amount = resp.total_total_withdraw_amount;
            _this.DATA.total_total_bet_money_amount = resp.total_total_bet_money_amount;
            _this.DATA.total_total_win_money_amount = resp.total_total_win_money_amount;
            _this.DATA.total_total_bet_bonus_amount = resp.total_total_bet_bonus_amount;
            _this.DATA.total_total_win_bonus_amount = resp.total_total_win_bonus_amount;
            _this.DATA.total_total_brand_ggr_amount = resp.total_total_brand_ggr_amount;
            _this.DATA.total_total_brand_profit_amount = resp.total_total_brand_profit_amount;
            _this.DATA.total_total_sub_partner_profit_amount = resp.total_total_sub_partner_profit_amount;
            _this.DATA.total_total_own_partner_profit_amount = resp.total_total_own_partner_profit_amount;
            _this.DATA.total_total_completed_bonus_amount = resp.total_total_completed_bonus_amount;
            _this.DATA.total_total_completed_bonus_count = resp.total_total_completed_bonus_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    usr_partner_id: resp.list[i].usr_partner_id,
                    usr_partner_login: resp.list[i].usr_partner_login,
                    usr_partner_subagents_count: resp.list[i].usr_partner_subagents_count,
                    total_deposits_count: resp.list[i].total_deposits_count,
                    total_withdraws_count: resp.list[i].total_withdraws_count,
                    total_deposit_amount: resp.list[i].total_deposit_amount,
                    total_withdraw_amount: resp.list[i].total_withdraw_amount,
                    total_bet_money_amount: resp.list[i].total_bet_money_amount,
                    total_win_money_amount: resp.list[i].total_win_money_amount,
                    total_bet_bonus_amount: resp.list[i].total_bet_bonus_amount,
                    total_win_bonus_amount: resp.list[i].total_win_bonus_amount,
                    total_brand_ggr_amount: resp.list[i].total_brand_ggr_amount,
                    total_sub_partner_profit_amount: resp.list[i].total_sub_partner_profit_amount,
                    total_own_partner_profit_amount: resp.list[i].total_own_partner_profit_amount,
                    total_brand_profit_amount: resp.list[i].total_brand_profit_amount,
                    total_completed_bonus_amount: resp.list[i].total_completed_bonus_amount,
                    total_completed_bonus_count: resp.list[i].total_completed_bonus_count,
                    is_own_brand_partner: resp.list[i].is_own_brand_partner,
                    total: false
                });
            }
            _this.DATA.data_total.push({
                usr_partner_id: 0,
                usr_partner_login: "ИТОГО",
                usr_partner_subagents_count: 0,
                total_deposits_count: _this.DATA.total_total_deposits_count,
                total_withdraws_count: _this.DATA.total_total_withdraws_count,
                total_deposit_amount: _this.DATA.total_total_deposit_amount,
                total_withdraw_amount: _this.DATA.total_total_withdraw_amount,
                total_bet_money_amount: _this.DATA.total_total_bet_money_amount,
                total_win_money_amount: _this.DATA.total_total_win_money_amount,
                total_bet_bonus_amount: _this.DATA.total_total_bet_bonus_amount,
                total_win_bonus_amount: _this.DATA.total_total_win_bonus_amount,
                total_brand_ggr_amount: _this.DATA.total_total_brand_ggr_amount,
                total_sub_partner_profit_amount: _this.DATA.total_total_sub_partner_profit_amount,
                total_own_partner_profit_amount: _this.DATA.total_total_own_partner_profit_amount,
                total_brand_profit_amount: _this.DATA.total_total_brand_profit_amount,
                total_completed_bonus_amount: _this.DATA.total_total_completed_bonus_amount,
                total_completed_bonus_count: _this.DATA.total_total_completed_bonus_count,
                is_own_brand_partner: false,
                total: true
            });
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    ReportTotalProfitListCtl.prototype.doExportObjectArray = function (dtRange, onDone) {
        var _this = this;
        var _data = [];
        this.LoadData(dtRange, function () {
            for (var i = 0; i < _this.DATA.data.length; i++) {
                _data.push({
                    usr_partner_login: _this.DATA.data[i].usr_partner_login,
                    total_deposits_count: _this.DATA.data[i].total_deposits_count,
                    total_withdraws_count: _this.DATA.data[i].total_withdraws_count,
                    total_deposit_amount: _this.DATA.data[i].total_deposit_amount,
                    total_withdraw_amount: _this.DATA.data[i].total_withdraw_amount,
                    total_bet_money_amount: _this.DATA.data[i].total_bet_money_amount,
                    total_win_money_amount: _this.DATA.data[i].total_win_money_amount,
                    total_bet_bonus_amount: _this.DATA.data[i].total_bet_bonus_amount,
                    total_win_bonus_amount: _this.DATA.data[i].total_win_bonus_amount,
                    total_brand_ggr_amount: _this.DATA.data[i].total_brand_ggr_amount,
                    total_sub_partner_profit_amount: _this.DATA.data[i].total_sub_partner_profit_amount,
                    total_own_partner_profit_amount: _this.DATA.data[i].total_own_partner_profit_amount,
                    total_brand_profit_amount: _this.DATA.data[i].total_brand_profit_amount,
                    total_completed_bonus_amount: _this.DATA.data[i].total_completed_bonus_amount,
                    total_completed_bonus_count: _this.DATA.data[i].total_completed_bonus_count,
                });
            }
            _data.push({
                usr_partner_login: "ИТОГО",
                total_deposits_count: _this.DATA.total_total_deposits_count,
                total_withdraws_count: _this.DATA.total_total_withdraws_count,
                total_deposit_amount: _this.DATA.total_total_deposit_amount,
                total_withdraw_amount: _this.DATA.total_total_withdraw_amount,
                total_bet_money_amount: _this.DATA.total_total_bet_money_amount,
                total_win_money_amount: _this.DATA.total_total_win_money_amount,
                total_bet_bonus_amount: _this.DATA.total_total_bet_bonus_amount,
                total_win_bonus_amount: _this.DATA.total_total_win_bonus_amount,
                total_brand_ggr_amount: _this.DATA.total_total_brand_ggr_amount,
                total_sub_partner_profit_amount: _this.DATA.total_total_sub_partner_profit_amount,
                total_own_partner_profit_amount: _this.DATA.total_total_own_partner_profit_amount,
                total_brand_profit_amount: _this.DATA.total_total_brand_profit_amount,
                total_completed_bonus_amount: _this.DATA.total_total_completed_bonus_amount,
                total_completed_bonus_count: _this.DATA.total_total_completed_bonus_count,
            });
            if (onDone) {
                onDone(_data);
            }
        });
    };
    return ReportTotalProfitListCtl;
}(BaseController_1.BaseController));
exports.ReportTotalProfitListCtl = ReportTotalProfitListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/rep_total_profit/ctl/RepTotalProfitCtl.ts
// module id = 1011
// module chunks = 0